<template>
    <div class="container-fluid p-0" v-if="active_home">
        
        <div class="J-home-map">
        <!-- navbar -->
        <!-- presentación -->
            <div class="justify-content-center aling-items-center m-0 p-0 J-home-container" >
                <div class="J-container-opacity-home" :class="{'show':showInfo}">
                    <div class="J-content-opacity-home">
                        <div class="J-title-primary">
                            AYNI - Sirviendo con amor
                        </div>
                        <button class="J-btn J-btn-primary J-btn-large" @click="goLogin()">¡Ingresa Ya!</button>
                        <div class="J-content-text-min">
                            <span class="J-text-min">"El corazón de la comunidad, latiendo por un mañana mejor."</span>
                        </div>
                    </div>
                    <div class="J-content-home-img" v-if="false">
                        <img src="/img/resources/leo.png" alt="">
                    </div>
                    <button class="J-btn-close" @click="showInfo=false"><i class="fas fa-times"></i></button>
                </div>
               <component-maps/>
            </div>
        </div>

        <div class="fondo1 J-home-content justify-content-center aling-items-center m-10" v-if="false">
                <!-- frase -->
            <div class="row">
                <div class="col-md-6 col-lg-6" >
                    <h2 class="J-title-home">Apps de Gootwork</h2>
                    <div class="SecInfogImg pb-1 col-12 col-md-4">
                        <div class="gwDef gwDefIzq">
                            <img src="/img/logo/favor.png" alt="Apoyo Voluntario">            
                            <div class="ovrly"></div>
                            <div class="form-row buttons">
                                <div class="col-12 m-a">
                                    <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ModalApoyo">
                                        ¿Qué Es? 
                                    </button>
                                </div> 
                            </div>                    
                        </div>                
                    </div>            
                    <div class="SecInfogImg col-12 col-md-4">
                        <div class="gwDef gwDefIzq">
                            <img src="/img/logo/bussness.png" alt="EmpSocial">            
                            <div class="ovrly"></div>
                            <div class="form-row buttons">
                                <div class="col-12 m-a">
                                    <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ModalNegocios">
                                        ¿Qué Es? 
                                    </button>
                                </div> 
                            </div>                    
                        </div>                
                    </div>
                    
                </div>
                <!-- Loging -->
                <div class="col-md-6 col-lg-4" style="padding-bottom: 20px;margin-top:25px">
                    <div class="card text-center" style="padding: 10px 5% 10px;">
                        <div class="card-body">                                
                            <p class="colLetra" style="font-weight: 700; font-size: 25px;" :class="'card-title'">INICIA SESIÓN YA!</p>
                            <v-form ref="form" v-model="validdata" lazy-validation @submit.prevent="validate">
                                <div class="row">                                        
                                    <div style="padding: 5px;" class="col-lg-12">
                                    <v-text-field
                                            v-model="loginuser.datauser"
                                            placeholder="Escriba su Nombre de Usuario o Email"
                                            single-line
                                            :rules="[rules.required,rules.space]"
                                            outlined
                                        ></v-text-field>
                                        <v-layout v-if="userexist">
                                            <label class ="fas fa-exclamation-triangle">Usuario no Registrado, por favor Registrese</label>
                                        </v-layout> 
                                    </div>
                                    <div style="padding: 5px;" class="col-lg-12">
                                        <v-text-field
                                            v-model="loginuser.password"
                                            :append-icon="showpassword ? 'fas fa-eye' : 'fas fa-eye-slash'"
                                            :rules="[rules.required, rules.min]"
                                            :type="!showpassword ? 'text' : 'password'"
                                            name="input-10-1"
                                            placeholder="Escriba su contraseña"
                                            @click:append="showpassword = !showpassword"
                                        ></v-text-field>
                                        <v-layout v-if="incorrectpassword">
                                            <label class ="fas fa-exclamation-triangle"> Contraseña Incorrecta</label>
                                        </v-layout> 
                                    </div>
                                </div>
                                <div style="padding-top: 10px;">
                                    <button type="submit" class="btn btn-lg" style="background:#11679a;color:white">INICIAR SESIÓN</button>
                                </div>
                                <div style="padding-top: 10px;">
                                    <p class="colLetra" @click="opendialogforgetpassword" style="cursor:pointer">¿Has olvidado tu contraseña?</p>
                                </div>
                                <div class="form-inline row">
                                    <div class="col-sm-4 icono">
                                        <i @click="LoginwithFacebook" class="i fab fa-facebook-f"></i>
                                    </div>
                                    <div class="col-sm-4 icono">
                                        <i @click="LoginwithTwitter" class="i fab fa-twitter"></i>
                                    </div>
                                    <div class="col-sm-4 icono">
                                        <i @click="LoginwithGoogle" class="i fab fa-google"></i>
                                    </div>
                                </div>
                                <p class="colLetra">¿Todavia no tienes una cuenta?
                                    <a style="text-decoration: underline blue" @click="goRegister">Registrate aqui</a>
                                </p>
                            </v-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div class="colabSty row justify-content-center" v-if="false">
        <h2 class="col-12 J-title-doble">Nuestros Colaboradores</h2>
        <div class="col-12 col-md-5 m-2">
            <div id="CarouselColab" class="carousel slide" data-ride="carousel">

                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <div class="card">
                            <img src="/img/logo/logo_twitter_400x400.png" alt="univesidades">
                        </div>
                        <h4 class="py-4">Universidades</h4>
                        <p>A nivel regional, nacional e internacional (Universidad Tecologica de Mexico "Ecatepec", y 3 más)</p>
                    </div>
                    <div class="carousel-item">
                        <div class="card">
                            <img src="/img/logo/logotipo.png" alt="Municipalidades">
                        </div>
                        <h4 class="py-4">Municipalidades</h4>
                        <p>Municipalidades comprometidas con el desarrollo de la poblacion y su cuidado, El Tambo, Huancayo, Ecatepec "Mexico" y 2 más</p>
                    </div>
                    <div class="carousel-item">
                        <div class="card">
                            <img src="/img/logo/46732.png" alt="Estudiantes">
                        </div>
                        <h4 class="py-4"> Estudiantes <br> y Maestros </h4>
                        <p>Son un total de 10 estudiantes y 2 maestros de diferentes lugares a nivel regional, nacional e internacional</p>
                    </div>
                    <div class="carousel-item">
                        <div class="card">
                            <img src="/img/logo/donativo_rapet.png" alt="ONG's">
                        </div>
                        <h4 class="py-4">ONG's</h4>
                        <p>Sumandose las ONG's en pro del apoyo social, "ONG Yoshiro, Manos Unidas" y 2 más</p>
                    </div>
                    <div class="carousel-item">
                        <div class="card">
                            <img src="/img/logo/rrhh.png" alt="Ciudadanos">
                        </div>
                        <h4 class="py-4">Ciudadanos Comprometidos</h4>
                        <p>Son alrrededor de 17 personas cada una con sus talentos que aportan a modo de consejeros y colaboradores</p>
                    </div>
                </div>
                <a class="carousel-control-prev" href="#CarouselColab" role="button" data-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#CarouselColab" role="button" data-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>
        </div>
        <div class="col-12 col-md-5 m-2">
            <p>Todos somos parte de un cambio y tú <br> ¿Qué esperas?</p>
            <section class="row mt-3">
                <div class="contador ocultar col-12 col-sm-12">
                    <i class="fa fa-3x fa-users"></i>
                    <div class="contador_cantidad" data-cantidad-total="43">0</div>
                    <h4>Colaboradores a Nivel <br>  Nacional e Internacional </h4>
                </div>                
            </section>
        </div>
        <div class="invitacion col-12 col-md-4">
            <h4>¿Deseas ser parte de nuestros colaboradores?</h4>
            <a target="_blanck" href="https://bit.ly/2zAgGtq" class="btn btn-primary" style="font-weight: 600;"> Claro que si </a>
        </div>
    </div>
    <div id="button-up">
        <i class="fas fa-angle-double-up"></i>
    </div>
        <!-- familia gootwork -->        
        <div class="containerFamilia" style="position:relative;" v-if="false">
            <div class="famWork">
               
                <h2 class="col-12 J-title-doble">Familia GootWork</h2>
            </div>
            <div class="colabSty cajaIzquierda" >
                <!--div class="quesGot imag">                    
                    <img src="/img/resources/palPaper.jpg" alt="Foto Empresa">                
                </div-->
                <p class="quesGot Itext">“GootWork” es antes que todo, un equipo integrado de jovenes 
                    apasionados por la investigación científica e innovación 
                    tecnológica, que genera una mejor calidad de vida integrada 
                    en los avances tecnológicos actuales y del futuro.</p>
            </div>
            <div class="colabSty cajaDerecha">  
                <p class="dona">¡Dona y ayudanos a seguir mejorando!</p>              
                <div class="text-center containerFamilia ">                   
                    <div class="tarjeta prim" >
                        <img src="/img/resources/tarjeta1.png" alt="tarjeta1">
                    </div>
                    <div class="tarjeta seg" >
                        <img src="/img/resources/tarjeta2.png" alt="tarjeta2">
                    </div>
                    <div class="tarjeta terc" >
                        <img src="/img/resources/tarjeta3.png" alt="tarjeta3">
                    </div>
                </div>
                <div class="containerFamilia ">
                    <p class="letr">Queremos ser una de las StartUps más jovenes e
                    innovadoras del Perú. Todos los aportes seran valiosos, nos ayudaran
                    a mejorar</p>
                    <!--div class="bot">
                        <button  class="btn btn-primary">
                            <i href="">Dejanos tus datos aqui</i>
                        </button>
                    </div-->
                </div>
            </div>
        </div>
        <div class="ourSty" style="padding: 20px;">
            <div class="row px-3" style="justify-content: center; display: none;">
                <form class="col-12 col-md-8 p-4 " style="background: white;">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputEmail4">Email</label>
                            <input type="email" class="form-control" id="inputEmail4">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="inputNumber">Celular</label>
                            <input type="number" class="form-control" id="inputNumber">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputMessage">Mensaje</label>
                        <textarea class="form-control" id="inputMessage" cols="20" rows="5"></textarea>
                    </div>
                    <button type="submit" class="btn btn-primary" style="font-weight: 600;">Enviar</button>
                </form>
            </div>
            <div class="rsSty row justify-content-center py-2 px-1">
                <div class="contador ocultar col-3 icoRs hvr-float-shadow" v-if="false"> <a target="_blanck" href="https://bit.ly/2T4xWOa" class="fab fa-facebook-f"> </a> </div>
                <div class="contador ocultar col-3 icoRs hvr-float-shadow"> <a target="_blanck" href="https://bit.ly/2AkI2Eb" class="fab fa-instagram"> </a> </div>
                <div class="contador ocultar col-3 icoRs hvr-float-shadow"> <a target="_blanck" href="https://bit.ly/2zAgGtq" class="fab fa-whatsapp"> </a> </div>
                <div class="contador ocultar col-3 icoRs hvr-float-shadow" v-if="false"> <a target="_blanck" href="https://bit.ly/2X9UIWv" class="fab fa-twitter"> </a> </div>
                <a href=""></a>
                <div class="col-12 pt-4"> © {{yearToday}} Ayni - <label style="cursor: pointer;" @click="goPagegootwork">Gootwork</label>. Todos los derechos reservados.
                </div>
            </div>
        </div>

        <!-- Modal Apoyo Voluntario-->
        <div class="row">
            <div class="modal fade col--sm-12 J-modal-home" id="ModalApoyo" tabindex="-1" role="dialog" aria-labelledby="ModalApoyoLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">                    
                        <div class="modal-header">
                            <h5 class="modal-title">Gootwork favor con favor</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            En la aplicación podras ver los pedidos básicos de las personas cercanas a ti, podras ayudarlos si deseas. Hay muchas formas, por ejemplo: una seria donando mis propios insumos a los que necesiten, otro, cuando de camino a la tienda, tengo en la aplicación un pedido de un vecino o amigo cercano, puedo llevarselo y acordar por interno el metodo de pago. De igual manera tu puedes hacer el pedido para que otros te puedan ayudar.
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <!-- Modal Tus Negocios-->
        <div class="row">
            <div class="modal fade col--sm-12 " id="ModalNegocios" tabindex="-1" role="dialog" aria-labelledby="ModalNegociosLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg">
                    <div class="modal-content">                    
                        <div class="modal-header">
                            <h5 class="modal-title">Gootwork Negocios</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            Como vendedor en la aplicación podras registrar cualquier tipo de negocio y como comprador podras ver negocios cerca a donde te encuentras, ademas podras realizar pedidos seleccionando un negocio que esté mas cerca
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
const alertify = require('alertifyjs')
import Maps from '@/components/Templates/Views/Maps'
import Navbar from '@/components/Templates/Views/Navbar'
import config from '../../../../config/env.example'
import { EventBus } from '../../../../helpers/eventbus/event-bus'

import { CouponStorage, IdentStorage } from '@/helpers/storage.js'

// Modelos
import LoginUser from '../../../../models/loginuser'
export default {
    data(){
        return{
            showInfo:true,
            userexist: false,
            yearToday: '',
            incorrectpassword: false,
            validdata: true,
            showpassword: true,
            loginuser: new LoginUser(),
            active_home:true,
            identStorage:new IdentStorage(),
            couponStorage:new CouponStorage(),
            session: false,
            rules: {
                required: value => !!value || 'Requerido',
                min: v => v.length >= 8 || 'Minimo 8 caracteres',
                emailMatch: () => ('The email and password you entered don\'t match'),
                space: value =>{
                    const pattern = /\s/
                    return !pattern.test(value) || 'No dejes espacios en blanco'
                }
            },
        }
    },
    created(){
        this.selectedQuery();
        var iden=this.identStorage.get();
        if(iden) this.active_home=false;
    },
    mounted(){
        require("@/utils/count.js");
        this.yearToday = new Date().getFullYear()
    },
    components:{
        'component-maps':Maps,Navbar,
    },
    methods:{
        goPagegootwork(){
            window.open('https://gootwork.com', '_blank')
        },
        goLogin(){
            EventBus.$emit('goLogin')
        },
        selectedQuery(){
            var {coupon,company}=this.$route.query;
            if(coupon){
                this.couponStorage.remove();
                var new_coupon={
                    coupon:coupon,
                    company:company
                };
                this.couponStorage.set(new_coupon);
            }
        },
        openmodalquestion(){
            EventBus.$emit('openmodalquestions')
        },
        opendialogforgetpassword(){
          EventBus.$emit('opendialogforgetpassword')
        },
        /****************** * Guardar datos para identificar si el usuarios ha iniciado sesión ***************************************************+*/
        saveIdentity() {
            this.$store.dispatch('saveIdentity', this.identity)
            localStorage.setItem('iden', JSON.stringify(this.identity))
            this.$store.dispatch('saveToken', this.token)
            localStorage.setItem('tok', this.token)
        },
        LoginwithFacebook(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/facebook`
        },

        LoginwithGoogle(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/google`
        },

        LoginwithTwitter(){
          //renderauthsocialnetwork.rendersocialnetwork = true
          window.location = `${config.host}auth/twitter`
        },
        goRegister(){
            EventBus.$emit('goRegister')
        },
        validate () {
          if (this.$refs.form.validate()) {
            this.snackbar = true
            //this.loginuser.dni = this.loginuser.dni
            this.loginuser.gettoken = true
            this.axios.post('users/loginuser',this.loginuser)
                /******************* * Login Exitoso!!!!******************************* */
                .then((res) => {
                  //console.log(res)
                    let msg = res.data.message
                    this.identity = res.data.user
                    this.token = res.data.token
                    //console.log(this.identity)
                    //console.log(this.token)

                    this.$socket.emit('join:room', this.identity._id)
                    setTimeout(() => {
                        this.saveIdentity()
                         window.location =  window.location.href
                        //this.activeSocket();
                        //window.location = '/'
                    }, 400)
                    //this.getidentity()
                    //this.getuserforLocalStorage()
                
                })
                /******************* * Login Errado!!!!********************************/
                .catch((err) => {
                    let msg = err.response.data.message

                    if (msg === "Usuario no Registrado, porfavor Registrese") {
                        this.userexist = true
                        document.getElementById('datauser').focus()
                        setTimeout(() => {
                            this.userexist = false
                        }, 5000)
                    }

                    if (msg === "La Contraseña es incorrecta, intentelo de nuevo") {
                        this.incorrectpassword = true
                        document.getElementById('password').focus()
                        setTimeout(() => {
                            this.incorrectpassword = false
                        }, 5000)
                    }

                    if(msg === 'Todos los campos son necesarios'){
                      alertify.error(msg)
                    }
                })
            }
        },
    }
}
</script>